import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <mask id="ursa-icon__ExclamationAlertErrorIcon__20__ida" fill="#fff">
            <path
                fillRule="evenodd"
                d="M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
                clipRule="evenodd"
            />
            <path
                fillRule="evenodd"
                d="M10 11.201a.7.7 0 0 0 .7-.7v-3.1a.7.7 0 1 0-1.4 0v3.1a.7.7 0 0 0 .7.7"
                clipRule="evenodd"
            />
            <path d="M9.25 12.77a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0" />
        </mask>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 11.201a.7.7 0 0 0 .7-.7v-3.1a.7.7 0 1 0-1.4 0v3.1a.7.7 0 0 0 .7.7"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M9.25 12.77a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0" />
        <path
            fill="currentColor"
            d="M9.25 12.77h-1.5zm.75.75v-1.5zm.75-.75h-1.5zm-.75-.75v-1.5zM5.9 10A4.1 4.1 0 0 1 10 5.9v-3A7.1 7.1 0 0 0 2.9 10zm4.1 4.1A4.1 4.1 0 0 1 5.9 10h-3a7.1 7.1 0 0 0 7.1 7.1zm4.1-4.1a4.1 4.1 0 0 1-4.1 4.1v3a7.1 7.1 0 0 0 7.1-7.1zM10 5.9a4.1 4.1 0 0 1 4.1 4.1h3A7.1 7.1 0 0 0 10 2.9zm0-4.4A8.5 8.5 0 0 0 1.5 10h3A5.5 5.5 0 0 1 10 4.5zm8.5 8.5A8.5 8.5 0 0 0 10 1.5v3a5.5 5.5 0 0 1 5.5 5.5zM10 18.5a8.5 8.5 0 0 0 8.5-8.5h-3a5.5 5.5 0 0 1-5.5 5.5zM1.5 10a8.5 8.5 0 0 0 8.5 8.5v-3A5.5 5.5 0 0 1 4.5 10zm7.7.501a.8.8 0 0 1 .8-.8v3a2.2 2.2 0 0 0 2.2-2.2zm0-3.1v3.1h3v-3.1zm.8.8a.8.8 0 0 1-.8-.8h3A2.2 2.2 0 0 0 10 5.2zm.8-.8a.8.8 0 0 1-.8.8v-3a2.2 2.2 0 0 0-2.2 2.2zm0 3.1v-3.1h-3v3.1zm-.8-.8a.8.8 0 0 1 .8.8h-3a2.2 2.2 0 0 0 2.2 2.2zM7.75 12.77A2.25 2.25 0 0 0 10 15.02v-3a.75.75 0 0 1 .75.75zM10 15.02a2.25 2.25 0 0 0 2.25-2.25h-3a.75.75 0 0 1 .75-.75zm2.25-2.25A2.25 2.25 0 0 0 10 10.52v3a.75.75 0 0 1-.75-.75zM10 10.52a2.25 2.25 0 0 0-2.25 2.25h3a.75.75 0 0 1-.75.75z"
            mask="url(#ursa-icon__ExclamationAlertErrorIcon__20__ida)"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
